module.exports = __webpack_public_path__ + "img/11_87.7b1561cb.png";